<div [style]="style">
  <canvas
    baseChart
    [data]="chartData"
    [type]="chartType"
    [options]="chartOptions"
  >
  </canvas>
</div>
